<style>
.lbl-title {
  color: red;
  font-weight: bold;
  font-size: 20px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Eliminar proveedor de cuenta</b-card-header>

      <b-card-body v-if="MostrarMensajeResuesta">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultadoRespuesta.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="resultadoRespuesta.Icono"></i>
              </span>
              <br />
              <span class="alert-inner--text" v-html="resultadoRespuesta.Texto"></span>
              <br />
              <span
                class="alert-inner--text"
                v-html="resultadoRespuesta.TextoSecundario"
                style="font-size: 13px;"
              ></span>
            </base-alert>
          </div>
        </div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="GoBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else>
        <div class="col-md-12 text-center lbl-title">Eliminar proveedor de cuenta</div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >¿Queré eliminar las cuentas agendadas?</div>
        <div class="col-md-12 text-center">
          <img src="img/icons/Trash-2x.png" />
        </div>
        <div class="col-md-12 text-center" style="padding-top:30px;font-size:13px">Cuentas en</div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:15px; font-weight:bold"
        >{{Psp.Name}}</div>
        <div
          v-if="AccountsLength > 0"
          style="overflow-y:scroll;max-height: 250px;overflow-y: auto;"
        >
          <div
            class="row"
            v-for="item in Accounts"
            v-bind:key="item.Id"
            style="padding: 5px; border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
          >
            <div class="col-2">
              <img :src="Psp.Image" class="circle-img" style="width: 50px" alt />
            </div>
            <div class="col-6 items-cuenta">
              <div class="row item-name">{{item.Name}}</div>
              <div class="row item-cbu">CBU: {{item.CVU_CBU}}</div>
            </div>
          </div>
        </div>
        <div class="row" style="padding-top: 30px">
          <div class="col-md-12 text-center">
            <base-button type="danger" size="md" @click="GoBack">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </base-button>
            <base-button type="success" size="md" @click="ConfirmDeleteAccounts">
              <i class="fa fa-check-circle fa-fw"></i>Aceptar
            </base-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import confirmHelpers from "@/helpers/confirmHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  props: {
    PspIDProp: Number
  },
  components: {},
  data() {
    return {
      PspID: this.PspIDProp,
      Psp: null,
      Accounts: [],
      AccountsLength: 0,
      MostrarMensajeResuesta: false,
      resultadoRespuesta: {
        Texto: "",
        TextoSecundario: "",
        Tipo: "",
        Icono: ""
      }
    };
  },
  methods: {
    GetAccountsPspFromPsp() {
      let context = this;

      axiosHelpers.axiosGet(
        "RecruitmentAccountsPsp/GetAccountsPspFromPsp",
        { PspID: context.PspID },
        context,
        function(data) {
          context.Psp = data.ResponseVM.ItemPsp;

          context.Accounts = data.ResponseVM.ItemsCuentas;
          context.AccountsLength = data.ResponseVM.ItemsCuentas.length;
        }
      );
    },
    GoBack() {
      this.$router.push("miscuentas");
    },
    ConfirmDeleteAccounts() {
      let context = this;

      confirmHelpers.showConfirm(
        "¿Estás seguro que querés eliminar las cuentas del proveedor " +
          context.Psp.Name +
          "?",
        context,
        function() {
          context.DeleteAccounts();
        }
      );
    },
    DeleteAccounts() {
      let context = this;

      axiosHelpers.axiosPostWithoutAlerts(
        "RecruitmentAccountsPsp/DeleteAccountsPspFromPsp",
        { PspID: context.PspID },
        context,
        function(data) {
          context.MostrarMensajeResuesta = true;
          if (data.ResponseVM.Success) {
            context.resultadoRespuesta = {
              Texto: "Operación realizada con éxito!",
              TextoSecundario: "Proveedor de cuenta eliminado",
              Tipo: "success",
              Icono: "fa fa-fw fa-check-circle"
            };
          } else {
            if (data.Alerts.length > 0) {
              context.resultadoRespuesta = {
                Texto: data.Alerts[0].Message,
                Tipo: "danger",
                Icono: "fa fa-fw fa-times-circle"
              };
            }
          }
        }
      );
    },
  },
  computed: {},
  beforeMount: function() {
    this.GetAccountsPspFromPsp();
  }
};
</script>